// replace single quote with escape + single quote. disable eslint because 2 rules get broken
/* eslint-disable */
export function escapeSingleQuotes(str: string) {
  return str.replace(/(?<!\\)\'/g, "\\'");
}
/* eslint-enable */
